import { render, staticRenderFns } from "./CellRendererTags.vue?vue&type=template&id=1467d907&"
import script from "./CellRendererTags.vue?vue&type=script&lang=js&"
export * from "./CellRendererTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports